import { Input } from "@/components/ui/input";

import { NumericInputProps } from "../../types/numericInput";

const NumericInput = (props: NumericInputProps) => {
  const { value, step, min, max, onChange } = props;
  return (
    <Input
      type="number"
      step={step ?? 1}
      min={min ?? 0}
      max={max}
      value={value}
      onChange={(e) => onChange(Number(e.target.value))}
      className="w-16 h-7 text-center text-xs mx-auto p-1 bg-background"
    />
  );
};

export default NumericInput;
